export const defaultMessageVariables = [
    {
        name: "Nome do Contato",
        value: "{{name}} "
    },
    {
        name: "Usuário",
        value: "{{user.name}} "
    },
    {
        name: "Saudação",
        value: "{{ms}} "
    },
    {
        name: "Número do Protocolo",
        value: "{{protocol}} "
    },
    {
        name: "Data",
        value: "{{date}} "
    },
    {
        name: "Hora",
        value: "{{hour}} "
    },
    {
        name: "ID do Ticket",
        value: "{{ticket_id}} "
    },
    {
        name: "Fila",
        value: "{{queue}} "
    },
    {
        name: "Conexão",
        value: "{{connection}} "
    }
];
